import { render } from "./edit-client-fiscal.vue?vue&type=template&id=89df5c5c"
import script from "./edit-client-fiscal.vue?vue&type=script&lang=js"
export * from "./edit-client-fiscal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__